(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDomainsDeleteController',TabDomainsDeleteController);

    TabDomainsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabDomains'];

    function TabDomainsDeleteController($uibModalInstance, entity, TabDomains) {
        var vm = this;
        vm.tabDomains = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabDomains.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
